import { render, staticRenderFns } from "./PageScroll.vue?vue&type=template&id=6214969d&scoped=true&"
import script from "./PageScroll.vue?vue&type=script&lang=js&"
export * from "./PageScroll.vue?vue&type=script&lang=js&"
import style0 from "./PageScroll.vue?vue&type=style&index=0&id=6214969d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6214969d",
  null
  
)

export default component.exports